import React, { useEffect, useState } from 'react';
import PropTypes from 'prop-types';
import AppBar from '@material-ui/core/AppBar';
import CssBaseline from '@material-ui/core/CssBaseline';
import Divider from '@material-ui/core/Divider';
import Drawer from '@material-ui/core/Drawer';
import Hidden from '@material-ui/core/Hidden';
import IconButton from '@material-ui/core/IconButton';
import List from '@material-ui/core/List';
import ListItem from '@material-ui/core/ListItem';
import ListItemIcon from '@material-ui/core/ListItemIcon';
import ListItemText from '@material-ui/core/ListItemText';
import MenuIcon from '@material-ui/icons/Menu';
import WorkIcon from '@material-ui/icons/Work';
import AccountBoxIcon from '@material-ui/icons/AccountBox';
import ExitToAppIcon from '@material-ui/icons/ExitToApp';
import Toolbar from '@material-ui/core/Toolbar';
import Typography from '@material-ui/core/Typography';
import { makeStyles, useTheme } from '@material-ui/core/styles';
import { useHistory } from 'react-router-dom';
import Avatar from '@material-ui/core/Avatar';
import axios from 'axios'
import HomeParticipant from '../Participant/Home'

const drawerWidth = 240;

const useStyles = makeStyles((theme) => ({
  root: {
    display: 'flex',
  },
  drawer: {
    [theme.breakpoints.up('sm')]: {
      width: drawerWidth,
      flexShrink: 0,
    },
  },
  appBar: {
    [theme.breakpoints.up('sm')]: {
      width: `calc(100% - ${drawerWidth}px)`,
      marginLeft: drawerWidth,
    },
  },
  menuButton: {
    marginRight: theme.spacing(2),
    [theme.breakpoints.up('sm')]: {
      display: 'none',
    },
  },
  // necessary for content to be below app bar
  toolbar: theme.mixins.toolbar,
  drawerPaper: {
    width: drawerWidth,
  },
  content: {
    flexGrow: 1,
    padding: theme.spacing(3),
    marginTop: theme.spacing(3),
  },
  largeAvatar: {
    width: theme.spacing(10),
    height: theme.spacing(10),
  },
}));

function MenuHome(props) {
  const { window } = props;
  const classes = useStyles();
  const theme = useTheme();
  const history = useHistory();
  const [user, setUser] = useState([])
  const [photo, setPhoto] = useState('')
  const [mobileOpen, setMobileOpen] = React.useState(false);

  useEffect(() => {
    async function fetchData() {
      const token = localStorage.getItem('token');
      var config = {
        method: 'get',
        url: `${process.env.REACT_APP_API}/participant/profile/read`,
        headers: { token: token }
      };

      try {
        axios(config)
          .then(function (response) {
            setUser(response.data)
            setPhoto(`${process.env.REACT_APP_API}/${response.data.participant_biodatum.photo}`)
          })
      } catch (error) {
        console.log('Error', error)
        history.push('/participant/login')
      }
    }

    fetchData()
  }, [user.id, history]);

  const handleDrawerToggle = () => {
    setMobileOpen(!mobileOpen);
  };

  const drawer = (
    <div>
      <div className={classes.toolbar} style={{
        display: 'flex',
        justifyContent: 'center',
        alignItems: 'center',
        flexDirection: 'column',
        marginTop: '6%',
        marginBottom: '20px'
      }}>
        <Avatar alt="Photo" src={photo} className={classes.largeAvatar} />
        <Typography variant="h6" gutterBottom style={{
          textTransform: 'uppercase'
        }}>
          {user.first_name} {user.last_name}
        </Typography>
        <Typography variant="subtitle2" gutterBottom style={{
          textTransform: 'uppercase'
        }}>
          {user.reg_no}
        </Typography>
      </div>
      <Divider />
      <List>
        <ListItem button onClick={() => history.push({
          pathname: '/menu/home'
        })}>
          <ListItemIcon><WorkIcon /></ListItemIcon>
          <ListItemText primary='Jobs' />
        </ListItem>
      </List>
      <Divider />
      <List>
        <ListItem button onClick={() => history.push({
          pathname: '/menu/scholar'
        })}>
          <ListItemIcon><AccountBoxIcon /></ListItemIcon>
          <ListItemText primary='Scholarship' />
        </ListItem>
      </List>
      <Divider />
      <List>
        <ListItem button onClick={() => history.push({
          pathname: '/menu/profile'
        })}>
          <ListItemIcon><AccountBoxIcon /></ListItemIcon>
          <ListItemText primary='Profile' />
        </ListItem>
      </List>
      <Divider />
      <List>
        <ListItem button onClick={() => {
          localStorage.clear()
          history.push('/participant/login')
        }}>
          <ListItemIcon><ExitToAppIcon /></ListItemIcon>
          <ListItemText primary='Log Out' />
        </ListItem>
      </List>
    </div>
  );

  const container = window !== undefined ? () => window().document.body : undefined;

  return (
    <div className={classes.root}>
      <CssBaseline />
      <AppBar position="fixed" className={classes.appBar}>
        <Toolbar>
          <IconButton
            color="inherit"
            aria-label="open drawer"
            edge="start"
            onClick={handleDrawerToggle}
            className={classes.menuButton}
          >
            <MenuIcon />
          </IconButton>
        </Toolbar>
      </AppBar>
      <nav className={classes.drawer} aria-label="mailbox folders">
        {/* The implementation can be swapped with js to avoid SEO duplication of links. */}
        <Hidden smUp implementation="css">
          <Drawer
            container={container}
            variant="temporary"
            anchor={theme.direction === 'rtl' ? 'right' : 'left'}
            open={mobileOpen}
            onClose={handleDrawerToggle}
            classes={{
              paper: classes.drawerPaper,
            }}
            ModalProps={{
              keepMounted: true, // Better open performance on mobile.
            }}
          >
            {drawer}
          </Drawer>
        </Hidden>
        <Hidden xsDown implementation="css">
          <Drawer
            classes={{
              paper: classes.drawerPaper,
            }}
            variant="permanent"
            open
          >
            {drawer}
          </Drawer>
        </Hidden>
      </nav>
      <main className={classes.content}>
        <HomeParticipant />;
            </main>
    </div>
  );
}

MenuHome.propTypes = {
  /**
   * Injected by the documentation to work in an iframe.
   * You won't need it on your project.
   */
  window: PropTypes.func,
};

export default MenuHome;


